import { render } from "./widget-dop-okved-2.vue?vue&type=template&id=d2217cf2"
import script from "./widget-dop-okved-2.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-dop-okved-2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/widgets/widget-dop-okved-2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2217cf2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2217cf2', __exports__)) {
    api.reload('d2217cf2', __exports__)
  }
  
  module.hot.accept("./widget-dop-okved-2.vue?vue&type=template&id=d2217cf2", () => {
    api.rerender('d2217cf2', render)
  })

}


export default __exports__